module.exports = __webpack_public_path__ + "img/3.bb9bb7c1.png";